import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../ui/Breadcrumbs";
import useRoomEdit from "./useRoomEdit";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../ui/Progress";
import TopBar from "./components/TopBar";
import Box from "../../../ui/Box";
import RoomInfoDrawer from "../../components/RoomInfoDrawer";
import Tabs from "../../../ui/Tabs";
import RoomForm from "./components/RoomForm";
import Inventory from "./components/Inventory";
import Photos from "./components/Photos";
import {useMediaQuery} from 'react-responsive';

const useStyles = makeStyles(() => ({
  facilityRoot: {
    display: "flex",
    background: "#F6FBFF"
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
}));

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Материально-технические ресурсы",
    link: "/work/app/manage/resources/mattech"
  },
  {
    label: "Мои помещения и площадки",
    link: "/work/app/rooms"
  }
];

const tabitems = [
  {number: 0, caption: "Основная информация"},
  {number: 1, caption: "Инвентарная карточка"},
  {number: 2, caption: "Расписание"}
];

const RoomEdit = ({ match, history }) => {
  const { id } = match.params;
  const classes = useStyles();
  const {
    roomData: { roomInfo, photos, deleteModalOpen, isEdited, isUpdatingRoom },
    setRoomsData,
    getRoom,
    updateRoom,
    deleteRoom,
    addRoomPhoto,
    deleteRoomPhoto
  } = useRoomEdit();

  const [isEditable, setEditable] = React.useState(false);
  const returnBack = () => history.push("/work/app/rooms");
  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});

  useEffect(() => {
    getRoom(id);
  }, []);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить помещение?"
        open={deleteModalOpen}
        onConfirm={() => {
          deleteRoom(id);
          returnBack();
        }}
        handleClose={() => setRoomsData({ deleteModalOpen: false })}
      />
      <Breadcrumbs items={items} />
      {roomInfo ? (
        <div className={classes.facilityRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reloadRoom={() => getRoom(id)}
                returnBack={returnBack}
                updateRoom={() => {
                  updateRoom(id, roomInfo);
                  setEditable(false);
                }}
                isUpdatingRoom={isUpdatingRoom}
                openDeleteModal={() => setRoomsData({ deleteModalOpen: true })}
                disabled={!isEdited}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                <RoomForm
                  editmode={isEditable}
                  initialData={roomInfo.data}
                  disabled={!roomInfo.info.editable}
                  onFormChange={data =>
                    setRoomsData({ roomInfo: { ...roomInfo, data } })
                  }
                />
                <div style={{maxWidth: 774, minWidth: 400, marginLeft: 8}}>
                  <Photos
                    editmode={isEditable}
                    addImages={(photos) => addRoomPhoto(id, photos)}
                    onDeletePhoto={deleteRoomPhoto}
                    roomId={id}
                    photos={photos} />
                </div>
              </Box>
              <Inventory
                roomId={id}
                roomInfo={roomInfo}
                editmode={roomInfo.info.editable && isEditable}
              />
              <Box></Box>
            </Tabs>
          </div>
          {isLarge &&
          <RoomInfoDrawer roomId={id} open hideLink />}
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
};

export default withRouter(RoomEdit);
